module.exports = __webpack_public_path__ + "img/company_cert_bg_3.4ab7c6f0.png";